import { FunctionComponent, PropsWithChildren } from 'react';
import { useTimelineItemContext } from './TimelineItemContext';

interface TimelineItemContentLeftProps extends PropsWithChildren {}

export const TimelineItemContentLeft: FunctionComponent<TimelineItemContentLeftProps> = ({ children }) => {
  const { isFirst, isLast } = useTimelineItemContext();
  return <div className={`flex flex-1 flex-col items-end  ${isFirst ? 'pt-2' : 'pt-6'}`}>{children}</div>;
};
